import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import { path, isNil } from 'ramda';
import { Modal } from 'antd';

import { modalPropTypes } from 'components/Modals';
import TrainerMarkForm from './TrainerMarkForm';
import { putTrainerMarks, getEducationTimesheet } from 'actions/asyncActions';
import { DateField } from 'components/common/fields/DateTimeFields';

const getDate = path(['dt', 'date', 'from']);

const Title = ({ eventName, personName, date }) => (
    <span>
        {`${eventName}: ${personName} `}
        <DateField date={date} />
    </span>
);

const getRestEventColumnMarks = (eventId, personId, events) => {
    const eventColumnMarks = [];

    events.forEach(event => {
        const participant = event[eventId];
        if (participant && participant.participantId !== personId && !isNil(participant.presence)) {
            eventColumnMarks.push({
                personId: participant.participantId,
                presence: !!participant.presence,
                mark: participant.mark
            });
        }
    });

    return eventColumnMarks;
};

const stateToProps = state => ({
    events: getEducationTimesheet.selectData(state).items
});

@asyncConnect({
    putTrainerMarks: putTrainerMarks.withSuccessHandler(({ modal: { onCancel } }) => onCancel())
}, stateToProps)
export default class TrainerMarkModal extends Component {
    static propTypes = {
        ...modalPropTypes,
        params: PropTypes.shape({
            eventName: PropTypes.string.isRequired,
            item: PropTypes.object.isRequired,
            eventId: PropTypes.number.isRequired
        }),
        putTrainerMarks: PropTypes.object.isRequired
    }

    mapBeforeSubmit = ({ presence, mark }) => {
        const { params: { eventId, item: { participantId: personId }}, events } = this.props;

        return {
            id: eventId,
            marks: [
                ...getRestEventColumnMarks(eventId, personId, events),
                { personId, presence, mark }
            ]
        };
    }

    render() {
        const { modal, params: { eventName, item,  eventId }} = this.props;
        const title = <Title eventName={eventName} personName={item.participantName} date={getDate(item)} />;

        return (
            <Modal {...modal} title={title} footer={null}>
                <TrainerMarkForm
                    formAction={this.props.putTrainerMarks}
                    eventId={eventId}
                    item={item}
                    mapBeforeSubmit={this.mapBeforeSubmit}
                />
            </Modal>
        )
    }
}
